// extracted by mini-css-extract-plugin
module.exports = {"illustration":"MiniCard_illustration__llLIb","title":"MiniCard_title__hydmz","header":"MiniCard_header__ChdFJ","mini":"MiniCard_mini__6GDIN"};